import { render, staticRenderFns } from "./FinancialSummary.vue?vue&type=template&id=22624203&scoped=true"
import script from "./FinancialSummary.vue?vue&type=script&lang=js"
export * from "./FinancialSummary.vue?vue&type=script&lang=js"
import style0 from "./FinancialSummary.vue?vue&type=style&index=0&id=22624203&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22624203",
  null
  
)

export default component.exports